import { useNavigate } from "react-router-dom";

import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";
import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";
import ErrorBoundary from "@/ui/organisms/ErrorBoundary";

import {
    ViewUserPolicies,
    ViewTopBar,
    ViewNewExperienceSection,
    ViewNavigationSidebar,
} from "@/ui/compositionRootUI";

import { routerPaths } from "@/ui/router/routerPaths";
import Box from "@/ui/atoms/Box";
const PageUserPolicies = () => {
    const navigate = useNavigate();

    return (
        <LayoutFullScreen
            TopBarProps={{
                sx: {
                    backgroundColor: "var(--proda-white-110)",
                },
                onLogoClick: () => navigate(routerPaths.main.default()),
            }}
            MainContentProps={{
                sx: {
                    backgroundColor: "var(--proda-white)",
                    borderTop: "1px solid var(--primary-color)",
                },
            }}
            contentTopBar={<ViewTopBar />}
            contentTopBarBanner={<ViewNewExperienceSection />}
            contentSidebar={<ViewNavigationSidebar />}
        >
            <ErrorBoundary>
                <LayoutFillParentCentered>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                            height: "100%",
                        }}
                    >
                        <ViewUserPolicies />
                    </Box>
                </LayoutFillParentCentered>
            </ErrorBoundary>
        </LayoutFullScreen>
    );
};

export default PageUserPolicies;
